import core from "@/core";
import TranspirationCalculator from "@/core/TranspirationCalculator";

export default function () {
  return {
    methods: {
      getFilterDataList(list, lastDate) {
        const dataList = [];
        list.forEach((sensor) => {
          const sensingDate = core.date.instance(sensor.sensingAt);
          if (sensingDate.isBefore(lastDate)) {
            dataList.push(sensor);
          }
          if (sensor.transpiration == null) {
            sensor.transpiration = TranspirationCalculator.newInstance({
              dryBulbTemp: sensor.temp,
              relativeHumidity: sensor.humidity,
            });
            sensor.vpd = sensor.transpiration.vpd;
            sensor.hd = sensor.transpiration.hd;
          }
        });
        return dataList;
      },
      getAvgDataList(list) {
        const avgList = [];

        let avgItem = null;
        const avgKeyList = ["temp", "humidity", "co2", "solarRadiation", "vpd", "hd"];

        function pushAvgItem() {
          avgKeyList.forEach((key) => {
            avgItem[key] = TranspirationCalculator.convertDecimalPlacesValue(
              avgItem[key] / avgItem[key + "Count"],
            );
          });
          avgList.push(avgItem);
          avgItem = null;
        }

        list.forEach((sensor) => {
          const sensingDate = core.date.instance(sensor.sensingAt);
          sensor.date = sensingDate.toDate();
          const strSensingDate = sensingDate.format("YYYY-MM-DD HH");
          if (avgItem != null && strSensingDate !== avgItem.strDate) {
            pushAvgItem();
          }

          if (avgItem == null) {
            avgItem = {
              strDate: core.date
                .instance(sensor.sensingAt)
                .format("YYYY-MM-DD HH"),
            };
            avgItem.date = core.date.instance(avgItem.strDate).toDate();
            sensor.avgDate = avgItem.date;
          }
          avgKeyList.forEach((key) => {
            if (sensor[key] != null) {
              if (avgItem[key] == null) {
                avgItem[key] = 0;
                avgItem[key + "Count"] = 0;
              }
              avgItem[key] += sensor[key];
              avgItem[key + "Count"]++;
            }
          });
        });

        if (avgItem != null) {
          pushAvgItem();
        }

        list.forEach((sensor) => {
          if (sensor.avgDate != null) {
            for (let i = 0; i < avgList.length; i++) {
              const avg = avgList[i];
              if (avg.date === sensor.avgDate) {
                sensor.avgVpd = avg.vpd;
                sensor.avgHd = avg.hd;
                break;
              }
            }
          }
        });

        return avgList;
      },
    }
  };
}
